import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../services/api';
import type { GovernanceLogRecord, GovernanceLogCreatePayload } from '../../services/api/governance';

/** Types loaded in Exception Queue → History (resolutions + acknowledgments). */
export const EXCEPTION_QUEUE_GOVERNANCE_TYPES =
  'COMPLIANCE_RESOLUTION,COMPLIANCE_REOPEN,INTEGRITY_ACKNOWLEDGE,INTEGRITY_ACKNOWLEDGE_BATCH,ExceptionResolution';

export const useGovernanceLogs = () => {
  return useQuery({
    queryKey: ['governance', 'logs'],
    queryFn: async () => api.governance.logs.list(),
    staleTime: 60 * 1000,
  });
};

export const useGovernanceLogsForExceptionHistory = (
  filters?: { search?: string },
  options?: { enabled?: boolean },
) => {
  return useQuery({
    queryKey: ['governance', 'logs', 'exceptionHistory', filters ?? {}],
    queryFn: async () =>
      api.governance.logs.list({
        types: EXCEPTION_QUEUE_GOVERNANCE_TYPES,
        search: filters?.search?.trim() || undefined,
      }),
    staleTime: 60 * 1000,
    enabled: options?.enabled !== false,
  });
};

export const useCreateGovernanceLog = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: GovernanceLogCreatePayload) =>
      api.governance.logs.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['governance', 'logs'] });
    },
  });
};

